import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProjectsEditorService } from 'app/services/app/projects.service';

import {VersionsService } from '@core/services/versions/versions.service';


import * as  Objects from '@core/objects';
import { VersionFeedback } from '@core/models/version-feedback';

@Component({
    selector: 'app-projects-summary-item',
    templateUrl: './summary-item.component.html',
    styleUrls: ['./summary-item.component.scss']
})
export class ProjectsSummaryItemComponent implements OnInit, OnDestroy {
    // public readonly STATUS_LOADING = 0;
    // public readonly STATUS_DONE = 1;

    public readonly ACCESS_UPDATE_STAGE = "access_request_change_status";

    @Input() project: Objects.ExtendedRequest;
    @Input() exclude: Array<Objects.Label> = [];
    @Input() transitions: Objects.WorkflowTransition[];
    @Input() badge: string = '';
    // takes precedence over the event badge while the project waits for an update
    @Input() updating: boolean = false;
    @Input() opened: boolean = false;

    @Output() open = new EventEmitter<Objects.ExtendedRequest>();
    @Output() openSummary = new EventEmitter<Objects.ExtendedRequest>();
    @Output() actionLabelClick = new EventEmitter<Objects.Label>();
    @Output() actionStageClick = new EventEmitter<Objects.ExtendedRequest>();

    // public status: number = this.STATUS_LOADING;
    public displayOpen: boolean = false;
    public displayStages: boolean = false;
    public files: Array<Objects.File> = [];
    public diffLabels: Array<Objects.Label> = [];
    public feedbacksList: Array<VersionFeedback> = [];
    public nextStages: Objects.Status[] = [];
    public accessLoading: boolean = false;

    protected areLabelsObserved: boolean = false;

    private mouseDownTimer: any;
    private holding: boolean = false;
    private accessStageUpdate: boolean;
    private clickAndHoldTime: number = 1000; // 1 second

    protected projectAccessSubscriptor: Subscription;

    constructor(private versionSrv: VersionsService,
        private projectsEditorSrv: ProjectsEditorService ) { }

    ngOnInit() {        
        this.mouseDownTimer = null;
        // check if there are observer on the Output.
        this.areLabelsObserved = this.actionLabelClick.observed;
        if(this.project != null)
            this.updateDiffLabels();

        this.projectAccessSubscriptor = this.projectsEditorSrv.selectAccessAll()
            .subscribe((access) => {
                if(this.accessLoading){
                    this.accessStageUpdate = access[this.ACCESS_UPDATE_STAGE];
                    if(this.accessStageUpdate){
                        this.getNextStages(this.project);
                    }
                    this.accessLoading = false;
                }
            });
    }

    ngOnChanges(changes: SimpleChanges) {
        if(changes.exclude)
            this.updateDiffLabels();
    }

    ngOnDestroy(): void {
        if (this.mouseDownTimer) {
            clearInterval(this.mouseDownTimer); //release any timer just in case.
        }
    }

    //click & hold management may-2023
    onMouseDown() {
        this.mouseDownTimer = setTimeout(() => {
            // click and hold action here
            if(this.project != null){
                this.accessLoading = true;
                this.projectsEditorSrv.loadSingleAccess(this.project.id);
            }
            this.holding = true;
            this.displayStages = true;
        }, this.clickAndHoldTime); // set timeout to prevent click
    }

    onMouseUp() {
        if (this.mouseDownTimer) {
            clearInterval(this.mouseDownTimer); //release  timer
        }
    }

    onMouseLeave() {
        if (this.mouseDownTimer) {
            this.holding = false;
            clearInterval(this.mouseDownTimer); //release  timer
        }
    }

    onStagesMouseLeave() {
        this.holding = false;
        this.displayStages = false;
        clearInterval(this.mouseDownTimer); //release  timer
    }

    onStageClick(stage: Objects.Status){
        let request = Object.assign({},this.project);
        request.status = stage;

        // here we not assing to the real request the new stage, this sholud be done in dashboard store effect
        this.actionStageClick.emit(request);
        this.holding = false;
        this.displayStages = false;
        clearInterval(this.mouseDownTimer); //release  timer
        this.projectsEditorSrv.clearAccess();
    }

    toogleDetails() {
        this.opened = !this.opened; // maybe not needed
        
        this.openSummary.emit(this.project)
    }

    onLabelSelect(tag: Objects.Label) {
        this.actionLabelClick.emit(tag);
    }

    onOpen() {
        if(this.holding)   //prevent click when holding is active
            return;
        this.open.emit(this.project);
    }

    private updateDiffLabels() {
        this.diffLabels = this.project.labels.filter((label: Objects.Label) => !this.exclude.some((l) => l.id == label.id));
    }

    private getNextStages(project: Objects.Request){
        this.nextStages = this.transitions.filter((tr:Objects.WorkflowTransition) => tr.origin.id == project.status.id)
                .map((t: Objects.WorkflowTransition) => {return t.target});

        console.debug(" ### FOR  "+project.id +" next stages are ", this.nextStages);
        // return this.transitions.filter((tr:Objects.WorkflowTransition) => tr.origin.id == project.status.id)
        //                         .map((t: Objects.WorkflowTransition) => {return t.target});
    }

}
